import hua from '@hweb/hua-js';

export const M = {};
export const memberGrades = ['星会员', '银会员', '玫瑰金会员', '金会员', '铂金会员'];

export const memberGradesCharacters = ['P', 'A', 'X', 'B', 'I'];

export const pageType = 'h5';

export const language = 'CN';


export const HOTEL_STYLE_MAP_CN_TEXT = {
  4: '汉庭',
  64: '汉庭快捷',
  420: '汉庭',
  1: '禧玥',
  13: 'CitiGO',
  5: '海友',
  27: '花间堂',
  16: '桔子',
  32: '桔子',
  14: '水晶',
  6: '漫心',
  599: '美居',
  506: '美爵',
  12: '诺富特',
  2: '全季',
  3: '星程',
  7: '怡莱',
  9: '宜必思',
  514: '宜必思尚品',
  18: '汉庭',
  37: '施柏阁',
  45: '宋品',
  38: '城际'
};

export const brandMap = {
    汉庭: 'hanting',
    禧玥: 'xiyue',
    CitiGO: 'citigo',
    海友: 'haiyou',
    花间堂: 'huajiantang',
    桔子酒店: 'juzi',
    桔子精选: 'juzi',
    桔子水晶: 'juzishuijing',
    漫心: 'manxin',
    美居: 'meiju',
    美爵: 'meijue',
    诺富特: 'nuofute',
    全季: 'quanji',
    星程: 'xingcheng',
    怡莱: 'yilai',
    宜必思: 'yibisi',
    宜必思尚品: 'yibisishangpin',
    汉庭优佳: 'hanting',
    施柏阁: 'shiboge',
    宋品: 'songpin',
    城际: 'chengji'
};

export const jiProvinceMap = {
    上海: 'shanghai',
    上海市: 'shanghai',
    云南省: 'yunnan',
    北京市: 'beijing',
    内蒙古自治区: 'neimenggu',
    吉林省: 'jilin',
    四川省: 'sichuan',
    天津市: 'tianjin',
    宁夏回族自治区: 'ningxia',
    安徽省: 'anhui',
    山西省: 'shanxi',
    山东省: 'shandong',
    广东省: 'guangdong',
    广西壮族自治区: 'guangxi',
    黑龙江省: 'heilongjiang',
    江苏省: 'jiangsu',
    江西省: 'jiangxi',
    河北省: 'hebei',
    新疆维吾尔自治区: 'xinjiang',
    河南省: 'henan',
    浙江省: 'zhejiang',
    海南省: 'hainan',
    湖北省: 'hubei',
    湖南省: 'hunan',
    甘肃省: 'gansu',
    福建省: 'fujian',
    贵州省: 'guizhou',
    辽宁省: 'liaoning',
    西藏自治区: 'xizang',
    重庆市: 'chongqing',
    青海省: 'qinghai',
    陕西省: 'shanxi1',
};
export const jiProvinceCnMap = {
    上海: '上海',
    上海市: '上海',
    云南省: '云南',
    北京市: '北京',
    内蒙古自治区: '内蒙',
    吉林省: '吉林',
    四川省: '四川',
    天津市: '天津',
    宁夏回族自治区: '宁夏',
    安徽省: '安徽',
    山西省: '山西',
    山东省: '山东',
    广东省: '广东',
    广西壮族自治区: '广西',
    黑龙江省: '黑龙江',
    江苏省: '江苏',
    江西省: '江西',
    河北省: '河北',
    新疆维吾尔自治区: '新疆',
    河南省: '河南',
    浙江省: '浙江',
    海南省: '海南',
    湖北省: '湖北',
    湖南省: '湖南',
    甘肃省: '甘肃',
    福建省: '福建',
    贵州省: '贵州',
    辽宁省: '辽宁',
    西藏自治区: '西藏',
    重庆市: '重庆',
    青海省: '青海',
    陕西省: '陕西',
};



export const AGREEMENTS = {
	rwxz001: 'https://campaign.huazhu.com/static/activity/?objectClass=rwxz001&textonly=true',
	rwxz002: 'https://campaign.huazhu.com/static/activity/?objectClass=rwxz002&textonly=true',
	grhy001: 'https://campaign.huazhu.com/static/activity/?objectClass=grhy001&textonly=true',
	yssm001: 'https://campaign.huazhu.com/static/activity/?objectClass=yssm001&textonly=true',
}

export const UNIVERSAL_CONST = {
	PAGE_TYPE: {
		'H5': 'H5',
		'PC': 'PC',
	},
	PAGE_LAN: {
		'CN': 'CN',
		'TC': 'TC', //繁体中文
		'EN': 'EN',
	},
  AUTH_TYPE: {
    'wx': 'wx',
    'sms': 'sms',
    'roomno': 'roomno',
  }
}


export const HOTEL_STYLE_MAP = {
    4: 'hanting',
    64: 'hantingkuaijie',
    420: 'hanting',
    1: 'xiyue',
    13: 'citigo',
    5: 'haiyou',
    27: 'huajiantang',
    16: 'juzi',
    32: 'juzi',
    14: 'juzishuijing',
    6: 'manxin',
    599: 'meiju',
    506: 'meijue',
    12: 'nuofute',
    2: 'quanji',
    3: 'xingcheng',
    7: 'yilai',
    9: 'yibisi',
    514: 'yibisishangpin',
    18: 'hanting',
    37: 'shiboge',
    45: 'songpin',
    38: 'chengji'
};

export const NET_SUPPLIER = {
	ruijie: 'ruijie',
	linkbroad: 'linkbroad',
	amtt: 'amtt',
	cmcc: 'cmcc',
	fufu: 'fufu',
	awifi: 'awifi',
	jshb: 'jshb',
	awifi01: 'awifi01'
}

export const GATEWAY_PASS_TYPE = {
  'URL_JUMP': 'URL_JUMP',
  'JSONP': 'JSONP',
}


export const PAGE_PATH_MAP = {
	'succcess': {
		'H5': '/maccesssuccess',
		'PC': '/pcaccesssuccess',
	},
	'fail': {
		'H5': '/maccessfail',
		'PC': '/pcaccessfail',
	},
};
export const PAGE_PATH_MAP_EN = {
	'succcess': {
		'H5': '/menaccesssuccess',
		'PC': '/pcenaccesssuccess',
	},
	'fail': {
		'H5': '/menaccessfail',
		'PC': '/pcenaccessfail',
	},
};

export const Service_WeApp_Path = '/packages/serverPage/pages/tripMiddlePage/index'
export const Service_HuazhuApp_Path = 'hanting://main/hello'
export const hzPortalVerConst = {
  'V24': 'V24',
  'V22': 'V22',
  'v24': 'V24',
  'v22': 'V22'
}

const hzPageErrorMap = {
  '300208': '系统响应超时，请稍后重试',
}


export const getHzPageError = (code, hotelId = '') => {
  let _text = hzPageErrorMap[code]
  if (!_text) {
    if (code == '300209') {
      let _tmpStr = hotelId ? `（${hotelId}）` : ''
      _text = `此门店${_tmpStr}已停业，WiFi认证功能无法使用。如有疑问请门店联系城区IT`
    } else {
      _text = '请稍后重试'
    }
  }
  return _text 
}

/**
 * 品牌编号与品牌英文标识映射
 * 用于快速查询品牌资源（如logo、背景图）
 */
export const BRAND_NO_MAP = {
  1: 'quanji',           // 全季
  2: 'hanting',          // 汉庭
  3: 'haiyou',           // 海友
  4: 'xingcheng',        // 星程
  5: 'xiyue',            // 禧玥
  6: 'manxin',           // 漫心
  7: 'yilai',            // 怡莱
  9: 'yibisi',           // 宜必思
  10: 'meiju',           // 美居
  11: 'yibisishangpin',  // 宜必思尚品
  12: 'nuofute',         // 诺富特
  13: 'meijue',          // 美爵
  14: 'citigo',          // CitiGO
  15: 'juzishuijing',    // 桔子水晶
  16: 'hanting',         // 汉庭优佳
  18: 'juzi',            // 桔子酒店
  27: 'huajiantang',     // 花间堂
  28: 'meilun',          // 美仑
  29: 'meilungj',        // 美仑国际
  37: 'shiboge',         // 施柏阁
  38: 'chengji',         // 城际
  39: 'meilunbh',        // 美仑美奂
  42: 'nihao',           // 你好
  43: 'shibogedg',       // 施柏阁大观
  45: 'songpin',         // 宋品
  48: 'yongleben',       // 永乐半山
  63: 'quanjidg',        // 全季大观
  64: 'hantingkuaijie',  // 汉庭快捷
}

/**
 * 品牌编号与品牌中文名称映射
 * 用于展示品牌名称
 */
export const BRAND_NO_CN_MAP = {
  1: '全季',
  2: '汉庭',
  3: '海友',
  4: '星程',
  5: '禧玥',
  6: '漫心',
  7: '怡莱',
  9: '宜必思',
  10: '美居',
  11: '宜必思尚品',
  12: '诺富特',
  13: '美爵',
  14: 'CitiGO',
  15: '桔子水晶',
  16: '汉庭优佳',
  18: '桔子酒店',
  27: '花间堂',
  28: '美仑',
  29: '美仑国际',
  37: '施柏阁',
  38: '城际',
  39: '美仑美奂',
  42: '你好',
  43: '施柏阁大观',
  45: '宋品',
  48: '永乐半山',
  63: '全季大观',
  64: '汉庭快捷',
}
export const BRAND_NO_TEXT_CN_MAP = {
  1: '全季',
  2: '汉庭',
  3: '海友',
  4: '星程',
  5: '禧玥',
  6: '漫心',
  7: '怡莱',
  9: '宜必思',
  10: '美居',
  11: '宜必思尚品',
  12: '诺富特',
  13: '美爵',
  14: 'CitiGO',
  15: '桔子水晶',
  16: '汉庭优佳',
  18: '桔子',
  27: '花间堂',
  28: '美仑',
  29: '美仑国际',
  37: '施柏阁',
  38: '城际',
  39: '美仑美奂',
  42: '你好',
  43: '施柏阁大观',
  45: '宋品',
  48: '永乐半山',
  63: '全季大观',
  64: '汉庭快捷',
}

/**
 * 获取品牌关键字
 * 优先使用 brandno，降级使用 hotelStyle
 * @param {number|string} brandNo - 品牌编号
 * @param {number|string} hotelStyle - 酒店风格编码（降级方案）
 * @returns {string} 品牌英文标识
 */
export const getBrandKey = (brandNo, hotelStyle) => {
  // 优先使用 brandNo
  if (brandNo && BRAND_NO_MAP[brandNo]) {
    return BRAND_NO_MAP[brandNo]
  }
  
  // 降级使用 hotelStyle
  if (hotelStyle && HOTEL_STYLE_MAP[hotelStyle]) {
    return HOTEL_STYLE_MAP[hotelStyle]
  }
  
  // 都不可用时返回默认值
  return 'def'
}
